import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';

@Component({
  selector: 'app-my-patients',
  templateUrl: './my-patients.component.html',
  styleUrls: ['./my-patients.component.scss']
})
export class MyPatientsComponent implements OnInit {

  constructor(private dataService: DataService) { }

  	data:any = {patients:[], count:0};
  	role_id:any = '';
	key:any;
	limit = 20;
	search = "";
	department= 0;
	departments = [];
	edit = { 'treatment':'' };
	tags = [];
	tag = "";
	loading:any = 0;
	gender:any = "";
	dr1:any = "";
	dr2:any = "";
	lower:any = "";
	upper:any = "";
	showFilters:any = true;

	


  ngOnInit() {

  	this.key = localStorage.getItem('key');
	this.role_id = localStorage.getItem('role_id');

	this.tag = this.dataService.getLocalData("filterTag");

	this.loadPatients();
	this.loadDepartments();
	this.loadTags();

  }

  	loadPatients() {
		this.loading = 1;
		
		this.dataService.getMyPatients(this.limit, this.search, this.tag, this.gender, this.dr1, this.dr2, this.lower, this.upper).subscribe( (data: any )=> {
  			this.data = data;
			this.loading = 0;
		
  		
  		} );
	}

	toggleFilterVisibility(){
		this.showFilters = !this.showFilters;
	}

	loadDepartments() {
		
		this.dataService.getDepts().subscribe( (data: any )=> {
	  		this.departments = data;
	  		
	  	} );
	}

	loadTags(){
		this.dataService.getTags().subscribe( (data: any )=> {
	  		this.tags = data;
	  		
	  	} );
	}

	loadMore() {
		this.limit +=20;
		this.loadPatients();
	}

	searchPatients(search) {
		this.search = search;
		this.loadPatients();
	}

	searchTags(tag){
		this.tag = tag;
		this.dataService.setLocalData("filterTag", tag);
		this.loadPatients();
	}

	dateRegFilter(): void {
		if (this.dr1 && this.dr2 && this.isValidDate(this.dr1) && this.isValidDate(this.dr2)) {
		  console.log('Valid date range:', this.dr1, 'to', this.dr2);
		  this.loadPatients();
		} 
	  }
	  
	private isValidDate(date: any): boolean {
		return !isNaN(new Date(date).getTime());
	}

	ageRangeFilter(): void {
		if (this.isValidNumber(this.lower) && this.isValidNumber(this.upper) && this.upper >= this.lower) {
			console.log('Valid age range:', this.lower, 'to', this.upper);
			this.loadPatients();
		} 
	}
	
	private isValidNumber(value: any): boolean {
		return typeof value === 'number' && !isNaN(value);
	}

	downloadList(){
		var key = localStorage.getItem("key");
		window.open(this.dataService.REST_API_SERVER + "reports/patients_list"+"&tag="+this.tag+"&gender="+this.gender+"&dr1="+this.dr1+"&dr2="+this.dr2+"&lower="+this.lower+"&upper="+this.upper+"&key="+key);
	}
	  

}
